import apiClient from "./apiClient";

export const apiRequest = async (method, url, data = null, params = {}) => {
  try {
    const uppercaseMethod = method.toUpperCase();
    const config = {
      method: uppercaseMethod,
      url,
      params,
    };

    // ONLY add data if it's POST, PUT, or PATCH AND data is not null/undefined
    if (
      data !== null &&
      data !== undefined &&
      ["POST", "PUT", "PATCH"].includes(uppercaseMethod)
    ) {
      config.data = data;
    } else {
      // Explicitly delete/omit data for GET and DELETE so Axios sends NO body
      delete config.data;
    }

    const response = await apiClient(config);
    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
};

// Auth APIs
export const authLogin = async (user_id, password) => {
  return apiRequest("POST", "/auth/login", { user_id, password });
};

export const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
};

// export const getStoredUser = () => {
//   const user = localStorage.getItem("user");
//   return user ? JSON.parse(user) : null;
// };
export function getStoredUser() {
  try {
    const userStr = localStorage.getItem("user");
    if (!userStr || userStr === "undefined" || userStr === "null") {
      return null;
    }
    return JSON.parse(userStr);
  } catch (err) {
    // If local storage contains invalid JSON, clear it safely instead of crashing the app
    console.warn("Cleared corrupted user data from localStorage:", err);
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    return null;
  }
}

export const getStoredToken = () => {
  return localStorage.getItem("token");
};
